import { defineComponent as _defineComponent } from 'vue'
import PageService from '@/core/page.service';
import HideB2BPricesButton from '@/ui/chrome/HideB2BPricesButton.vue';
import ImpersonateModal from './ImpersonateModal.vue';
import { store } from '@/store';
import { computed, onMounted, ref } from 'vue';
import { useTranslations } from '@/core/translate.mixin';
import { useImpersonation } from '@/store/impersonation.composable';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortalTopBar',
  props: {
    whiteBackground: { type: Boolean }
  },
  setup(__props: any) {



const displayNameB2B = computed<string>(() => store.getters['app/displayNameB2B']);
const logoutUrl = computed<string>(() => store.getters['app/logoutUrl']);
const isCheckoutView = computed<boolean>(() => store.getters['app/isCheckoutView']);

const { impersonation, endImpersonation } = useImpersonation();

const impersonateModalOpen = ref<boolean>(false);

onMounted(() => {
    if (impersonation.value) {
        if (!impersonation.value.active) {
            PageService.softRedirect(impersonation.value.redirectUrlForReset);
        }

        impersonateModalOpen.value = !impersonation.value.active;
    }
});

const { t } = useTranslations();

const impersonationText = computed<string>(() => {
    const customerName = impersonation.value.customerName;
    return customerName
        ? t('Shared.Layout.MainNavigation.SalesConsultantImpersonation')
            .replace('{0}', impersonation.value.userId)
            .replace('{1}', customerName)
        : displayNameB2B.value;
});

async function openModal() {
    if (impersonation) {
        PageService.softRedirect(impersonation.value.redirectUrlForReset);

        if (impersonation.value.active) {
            await endImpersonation();
        }

        impersonateModalOpen.value = true;
    }
}


return { __sfc: true,displayNameB2B, logoutUrl, isCheckoutView, impersonation, endImpersonation, impersonateModalOpen, t, impersonationText, openModal, HideB2BPricesButton, ImpersonateModal }
}

})